import React from 'react'
import ErrorLogo from '../assets/Images/pagenotfoundlatest.png'
import AuthButton from './LogInPage/LoginButton';
import { RxHome } from 'react-icons/rx';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setErrorPage } from '../redux/Slices/loaderSlice';
import { setIsTestInstructionsOpen, setIsTestStarted } from '../redux/Slices/startFullTestSlice';
import logoNew from "../assets/Images/VerticalDarkLogo1.svg";
import sat from "../assets/Images/SATprep1.svg";
import { getItem } from '../utils/token';
import OnboardingBackground from '../components/ReUsableComponents/OnboardingBackground';

const ApiErrorPage = () => {
    const navigate =  useNavigate();
    const dispatch = useDispatch();

    const handleBackToHome = () => {
      getItem("userRole") === "PARENT" ? navigate('/parentdashboard') : navigate('/dashboard');
      dispatch(setErrorPage(false));
      dispatch(setIsTestStarted(false));
      dispatch(setIsTestInstructionsOpen(false));
    }
    
  return (
    <OnboardingBackground>
      <div className="flex flex-col justify-center items-center px-10 w-fit bg-satPrepTransWhite p-9 my-9 rounded-[28px]">
          <div className="flex flex-col items-center w-[720px] justify-between mx-auto my-9">
          <img src={logoNew} className="w-[260px] h-[163px]" alt="FullMarks Logo" />
            <img src={sat} className="w-[211px] h-[68px]"  alt="SATprep Logo" />
          
          <h1 className='font-gully text-[40px] font-bold text-satPrepAccent my-9'>
              Oops! Something Went Wrong...
          </h1>

          <img src={ErrorLogo} alt='error-logo' className='mx-auto w-[400px]'/>

          <div className='font-gully text-[18px] font-medium text-center my-9 text-satPrepBlack'>
            <p>Need Help? Ran into a problem? Reach out to our support</p>
            <p>team at <a href="mailto:support@fullmarks.io" className="text-satPrepAccent underline"> support@fullmarks.io</a>. The more details you can</p>
            <p>provide, the faster we can help you.</p>
          </div>
        </div>

        <div className='mx-auto'>
          <AuthButton
              text="Return To Home"
              icon={<RxHome size={24} />}
              iconPosition="left"
              onClick={handleBackToHome}
              loader={false}
          />
        </div>
      </div>
    </OnboardingBackground>
  )
}

export default ApiErrorPage